import React, { useState, createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext({
    authorized: false,
    id: 0,
    mem_id: 0,
    account: "",
    token: "",
    name: "",
    type: "",
    chinese_name: "",
    mem_status: "",
});

export const AuthProvider = ({ children }) => {
    const unAuthState = {
        authorized: false,
        id: 0,
        mem_id: 0,
        account: "",
        token: "",
        name: "",
        type: "",
        chinese_name: "",
    };

    const isAdminPath = window.location.pathname.startsWith('/adm');
    const localStorageKey = isAdminPath ? 'authAdm' : 'auth';
    const initialAuthState = { ...unAuthState };

    const localAuthStr = localStorage.getItem(localStorageKey);
    let localAuth = { ...initialAuthState };
    if (localAuthStr) {
        try {
            localAuth = JSON.parse(localAuthStr);
            if (localAuth.account && localAuth.token) {
                localAuth.authorized = true;
            }
        } catch (ex) {
            console.error('Error parsing auth data:', ex);
        }
    }

    const [auth, setAuth] = useState(localAuth);
    const navigate = useNavigate();

    const logout = () => {
        localStorage.removeItem(localStorageKey);
        setAuth({ ...initialAuthState });
        navigate(isAdminPath ? '/adm/admlogin' : '/');
    };

    return (
        <AuthContext.Provider value={{ ...auth, setAuth, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);